import React, { useEffect, useLayoutEffect, useState } from 'react';
import classNames from 'classnames';
import { useTranslation } from 'react-i18next';
import { FieldComponentProps, MessageActions } from '../../../types';
import { useDataContext } from '../../../context/dataContainer';
import TuaPayIcon from '../../../assets/svg/tuaPay.svg';


export const TuaPay: React.FC<FieldComponentProps> = ({
  toggleFetching,
  isFetching, notifyTuaPayBtnClicked,
  updateHeight,
}) => {
  const [integratorLabel, setIntegratorLabel] = useState({ isInit: false, label: null });
  const {
    paymentMethod, currencyCode, style, session, libInitializeId,
  } = useDataContext();

  const { t: tButtonsSelectors } = useTranslation('buttonsSelectors');

  const label = integratorLabel.label ??
    style?.paywithFinancingLabel ??
    tButtonsSelectors('pay_later_with') as string;

  const handleClick = async () => {
    notifyTuaPayBtnClicked?.();
    toggleFetching(true);
  };

  const handleMessage = (event: MessageEvent) => {
    if (event.data?.action === MessageActions.TUAPAY_SET_LABEL) {
      setIntegratorLabel({ isInit: true, label: typeof event.data.label === 'string' ? event.data.label : null });
    }

    window.removeEventListener('message', handleMessage);
  };

  useEffect(() => {
    window.addEventListener('message', handleMessage);

    window.parent.postMessage({
      action: MessageActions.TUAPAY_SET_LABEL,
      sessionId: session,
      libInitializeId,
    }, '*');

    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, []);

  useLayoutEffect(() => {
    if (!integratorLabel.isInit) return;

    updateHeight?.();
  }, [integratorLabel.isInit]);

  if (!paymentMethod?.tuaPay || currencyCode !== '840' || !integratorLabel.isInit) {
    return <></>;
  }

  return (
    <div>
      <button
        id="tuapay"
        type="button"
        onClick={handleClick}
        className={classNames('btn', 'tuapay-btn', 'secondary')}
        aria-label={label}
        disabled={isFetching}
      >
        <span>{label}</span>
        <TuaPayIcon aria-hidden />
      </button>
    </div>
  );
};
